import { POPUP_TYPE } from '../constants/constant';
import { popup } from './popup';
import { fetchForDocument } from '../backend/transport';

// The singleton is bound once at document entry, not to mutable tile settings.
const showError = (message, meta) => (meta
  ? popup(POPUP_TYPE.ERR, message, undefined, undefined, undefined, undefined, undefined, meta)
  : popup(POPUP_TYPE.ERR, message));
export const fetchData = (params) => fetchForDocument(params, showError);
